export default "__VITE_ASSET__CjSExEJO__"